"use strict";
import { getRequest, postRequest } from "@/services/RequestService";
import { getImage } from "./RequestService";

export const getApproveClaim = async request => {
  if (request.date_to !== undefined && request.date_from !== undefined) {
    const base_route = `claim/payment/status?date_from=${
      request.date_from
    }&date_to=${request.date_to}`;
    const response = await getRequest(base_route);
    return response;
  }
  const base_route = `claim/payment/status`;
  const response = await getRequest(base_route);
  return response;
};

// detail update
export const updateDeadline = async (request, id) => {
  const base_route = `claim/update/${id}/deadline`;
  const response = await postRequest(base_route, request);
  return response;
};

export const claimProceed = async (id, request) => {
  const base_route = `claim/proceed/${id}`;
  const response = await postRequest(base_route, request);
  return response;
};

// letter
export const getLetter = async claim_id => {
  const base_route = `claim/letter/${claim_id}/show`;
  const response = await getRequest(base_route);
  return response;
};

export const storeLetter = async request => {
  const base_route = `claim/letter/store`;
  const response = await postRequest(base_route, request);
  return response;
};

export const updateLetter = async (request, letter) => {
  const base_route = `claim/letter/${letter}/update`;
  const response = await postRequest(base_route, request);
  return response;
};

export const getLetterTemplate = async id => {
  const base_route = `claim/letter-template/${id}`;
  const response = await getRequest(base_route);
  return response;
};

// payment

export const getPayment = async payment => {
  const base_route = `claim/payment/${payment}/show`;
  const response = await getRequest(base_route);
  return response;
};

export const storePayment = async request => {
  const base_route = `claim/payment`;
  const response = await postRequest(base_route, request);
  return response;
};

export const markAsPaid = async request => {
  const base_route = `claim/payment/selected/paid`;
  const response = await postRequest(base_route, request);
  return response;
};
export const updatePaymentDate = async (request, claimPayment) => {
  const base_route = `claim/payment/date/${claimPayment}/update`;
  const response = await postRequest(base_route, request);
  return response;
};

// document

export const getDocuments = async id => {
  const base_route = `tba/claim/documents/${id}`;
  const response = await getRequest(base_route);
  return response;
};
export const storeDocument = async (request, id) => {
  const base_route = `claim/upload/${id}`;
  const response = await postRequest(base_route, request);
  return response;
};

export const openFile = async url => {
  const response = await getImage(url);
};

// terms and condition

export const getClaimByProduct = async id => {
  const base_route = `claim/terms-and-conditions/${id}/product`;
  const response = await getRequest(base_route);
  return response;
};

export const storeClaimTerms = async request => {
  const base_route = `claim/terms-and-conditions`;
  const response = await postRequest(base_route, request);
  return response;
};

export const updateClaimTerms = async (request, terms_id) => {
  const base_route = `claim/terms-and-conditions/${terms_id}/update`;
  const response = await postRequest(base_route, request);
  return response;
};

export const requestChange = async (claim_payment_id, request) => {
  const base_route = `claim/payment/${claim_payment_id}/payment-type`;
  const response = await postRequest(base_route, request);
  return response;
};

export const downloadLetter = async letter_id => {
  const base_route = `claim/letter/download/${letter_id}`;
  const response = await postRequest(base_route);
  return response;
};
